import _ from '/home/ps/root'
import { Ref, MASTER, equal, promise, Test, copy, cache} from '../../../global'
import {go} from '../../../io'
import {Toast} from '../../master/toast'
import React, {Suspense, Fragment, memo, forwardRef, useRef} from 'react'
import Loading from '../view/loading'
import More from '../view/more'
import Part from '../../part'
import Table from '../table'
import Album from './album'
// import { usePark } from '../../../hook/park'
const Control = React.lazy(() => import('./control'))
const ID = 'field'
let _field_ = 0
Ref[ID] = {}
const _Field_ = Ref[ID]
const getMedia = (lang, shard, park, db, pk) => {
  const r = park.media[db].default[pk] || cache(`${lang}${db}media${pk}`)
  if (r && r!=='find') return {
    src: `https://${shard}.${_.DOMAIN}/usr/${db}/media/${r.uri}.${r.type}`,
    alt: `${r.title}.${r.type}`,
    // original: r.title,
    title: r.title,
    type: r.type,
    pk: r.id,
    // medias: r.id,
  }
}
export const getMediaOf = (lang, shard, park, db, pk, id) => {
  const v = _.JSON_[id]
  const r = park[v]?.[db]?.default?.[pk] || cache(`${lang}${db}${v}${pk}`)
  if (!r || r=='find') return r
  if (id == 'medias') {
    const m = getMedia(lang, shard, park, db, pk)
    if (m) m[id] = pk
    return m
  }
  const f = JSON.parse(r.medias).reduce((found, fpk, fi) => {
    if (found) return found
    const m = getMedia(lang, shard, park, db, fpk)
    if (m) return m
    return found
  }, false)
  if (!f) return
  f.title = r.title
  f[id] = pk
  return f
}
export const getJson = (park, lang, shard, db, id, value) => {
  // let idx = 0
if (!Array.isArray(value))debugger
  return value.reduce((acc, _pk, idx) => {
    const r = getMediaOf(lang, shard, park, db, _pk, id)// || {src: '', alt: ''}
    if (r && r!='find') acc.push({...r, idx})
      // idx++
    // }
    // else
    // if (park[_.JSON_[id]]?.[db]?.default?.[_pk]=='find') {
    //   debugger
    //   // acc.push({pk: _pk, idx})
    //   // idx++
    // }
    // else debugger
    // idx++
    return acc
  }, [])
}
class Field extends Part {
  static ID = ID
  static HTM = 'input'
  static PROP = {'type': 'text'}
  static init = (prop, state) => {
    const { select, master, u, lang, login, cookie, vendor, param } = prop.master
    const { db, v, park } = prop
    const { pk } = prop.table
    const { verb, preview } = prop.row
    const { row, js, parts, field, sibling, onMount, onChange, V, I, id, extra } = prop.body
    const htm = prop.input || id=='modified' || _.PKS_.includes(id) ? 'div' : (V.htm || Field.HTM)
    const el = { ...V[htm] }
    const type = V.type || el.type
    const required = el.required || (prop.required || false)
    const minLength = el.minLength || 0
    const maxLength = el.maxLength
    const pattern = el.pattern
    let value = type=='json' ? JSON.parse(row[id] || '[]') : (typeof row[id] == 'undefined' ? '' : (type=='json' ? JSON.parse(row[id]) : row[id]))
    value = el.value || value
    value = el.type == 'checkbox' ? Boolean(value) : value
    const error = required && value && value.length>0 && value.length<minLength
    const json = _.JSON_[id] ? getJson(park, lang, vendor.home, db, id, value) : []
if (id!='reviews' && id!='selectmedia' && id!='jsondeliver' && type=='json' && !row[id]) debugger
    switch (id) {
    case 'feedback':
      value = row[id] || ''
    break
    case 'lang':
      value = prop.lang
    break
    case 'json':
      if (v=='login') {
        debugger
        value = el.value.replaceAll("react\\\\", '')
      }
    break
    case 'expire':
      if (row[id]) {
        const date = new Date(row[id]*1000)
        value = verb=='default' ? date.toDateString() : `${date.getFullYear()}-${date.getMonth()<10 ? '0':''}${date.getMonth()}-${date.getDate()<10 ? '0':''}${date.getDate()}`
      } else value = ''
    }
    const mediaModify = v=='media' && (verb!='default') && pk>0
    if (mediaModify) {
      if (id=='title') value = json.length ? json[0].title : park[v][db].default[pk].title
      if (id=='type') value = json.length ? json[0].type : park[v][db].default[pk].type
    }
    const expand = prop.ID=='cart' && id=='memo' && value ? true : false
    return {
      scroll: -1,
      required,
      selected: 0,
      expand,
      map: false,
      json,
      htm,
      value,
      error,
      stale: false,
      minLength,
      maxLength,
      pattern,
      type,
      preview: id=='medias' && (preview ? preview : json && json[0]),
      key: `${ db } ${ v } ${ pk } ${ verb } ${ id }${ extra }`,
    }
  }
  static getDerivedStateFromProps = (props, state) => {
    const { id, extra } = props.body
    if (!_.JSON_[id]) return state
    const iState = Field.init(props) // iState grows with park growth
    return {
      ...state,
      json: iState.json,
      value: iState.json.reduce((acc, el, i) => {
        if (!acc.includes(Number(el[id]))) acc.push(Number(el[id]))
        return acc
      }, []),
    }
  }
  constructor (props, context) {
    super(props, context)
    this.onSelectClick.bind(this)
    this.onChange.bind(this)
    this.callback.bind(this)
    this.setField.bind(this)
    this.init.bind(this)
    const { db, v } = props
    const { pk } = props.table
    const { id, extra } = props.body
    const { verb } = props.row
    this.state = Field.getDerivedStateFromProps(props, {
      ...Field.init(props),
      _id_: _field_++ ,
      key: `${ db } ${ v } ${ verb } ${ pk } ${ id }${ extra }`
    })
  }
  setField = s => this.setState(s)
  // set = arg => this.setState(arg, console.log(this.state)/* && this.referesh()*/)
  // set = (arg, callback=s=>console.log(s)) => this.setState(arg, callback(this.state))
  init = arg => {
    const p = this.props
    const { park, v, db, master } = p
    const { id } = p.body
    const { lang, vendor } = master
    console.log({ init: copy(this.state) })
    this.setState(Field.getDerivedStateFromProps(p, {
       ...this.state,
       ...arg
     }))
  }
  componentDidMount = () => {
    const p = this.props
    const s = this.state
    _Field_[s.key] = this
    const { id, extra } = p.body
    p.onFieldMount(id, {
      init: arg => this.init(arg),
      callback: this.callback,
      getState: () => this.state,
      setField: this.setField,//state => this.setField(state),
    })
  }
  componentWillUnmount = () => {
    const p = this.props
    const s = this.state
    const { db, v } = p
    const { pk } = p.table
    const { id, extra } = p.body
    const { verb } = p.row
    delete(_Field_[s.key])
    this.props.onFieldUnmount(id)
  }
  onSelectClick = e => {
    e.stopPropagation()
    // e.preventDefault()
    const p = this.props
    const state = this.state
    const { json, value } = state
    const { db, v, park } = p
    const { lang, vendorname, master, username } = p.master
    const pk = isNaN(p.table.pk) ? p.table.pk : Number(p.table.pk)
    const { id, extra } = p.body
    const { verb } = p.row
    const view = _.JSON_[id]
    const select = (id=='medias' || id=='items') ? 2 : 0
    console.log({fields: p.row.fields, db, v, pk, verb, id, extra}, prop.row.fields[id])
    // const selected = JSON.stringify(Fields[db][v][pk][verb][id][extra].state.value)
    const selected = JSON.stringify(prop.row.fields[id].getState().value)
    const url = `/${username}/${_.JSON_[id]}?lang=${lang}&db=${db}&v=${v}&pk=${pk}&verb=${verb}&id=${id}&select=${select}&selected=${selected}&cart=1`
    return p.singletonTab(e, url)
  }
  onChange = e => {
    e.preventDefault()
    e.stopPropagation()
    const p = this.props
    const { okI, cartI, lockI, u, lang, connected, vendor } = p.master
    const { db, v, park } = p
    const pk = isNaN(p.table.pk) ? p.table.pk : Number(p.table.pk)
    const { verb } = p.row
    const { row, id, extra } = p.body
    const { scroll, json, value, minLength, maxLength, error, stale, preview, type } = this.state
    const iState = Field.init(p)
    const isFile = e.target.type=='file' || id=='medias' || id=='selectmedia'
    let src, alt, title//, fpk = Number(e.target.dataset.pk || -1)
    const idx = Number(e.target.dataset.idx || 0)
    var _preview=iState.preview, _value=value, _stale=true, _error=false, _scroll=scroll
    const fpk = _.JSON_[id] && (e.target.dataset.pk || json[idx] && json[idx].pk || -1)
    console.log({isFile, 'e.target.dataset': e.target.dataset})
    const files = e.target.files// || Files[db] && Files[Caller] && Files.data.includes(fpk)
    switch (id) {
      case 'json': debugger
      case 'selectmedia':
      if (files?.length) {
        src = URL.createObjectURL(files[0])
        alt = files[0].name
        const dot = alt.split('.')
        const _type = dot.pop()
        const _title = dot.join('.')
        console.log({iState})
        const newFile = {src, alt, title: _title, type: _type, idx: json.length, pk: -json.length, file: files[0], uri: Math.floor(Date.now()/1000)}
        if (pk > 0 && json.length) json.splice(0, json.length)
        json.push(newFile)
      }
      break

      case 'medias':
      if (verb!='default') return
      _preview = getMediaOf(lang, vendor.home, park, db, fpk, id)
      _stale = false
      break
      case 'items':
      case 'reviews':
      if (verb != 'default') return
      _scroll = e.target.dataset.scroll
      _stale = false
      if (p.toggle) p.toggle()
    }
    // no break
    switch(e.target.type) {
      case 'checkbox': _value = e.target.checked; break
      // case 'number':
      default:
      if (_.JSON_[id]) break
      _value = e.target.value;
      if (_value.length < minLength) _error = true;
    }
    _stale = _.JSON_[id] ? JSON.stringify(json)!=JSON.stringify(iState.json) : _value!=iState.value
    console.log({_stale, value, iState, _value})
    _stale = p.neverStale ? false : _stale
    this.setState((s, p) => {
      if (p.ID=='cart' && id=='stock' && verb=='delete') {
        if (_value<0) _value=''
        else if (_value.toString().includes('.')) _value=_value.toString().split('.')[0]
      }
      if (p.ID=='cart' && id=='memo' && verb=='delete') {
        if (p.online.u?.lock) return Toast({response: [okI], content: [`${cartI} ${lockI}`], callback: r => {
          if (r) _value = p.cart[4]
        }})
      }
      if ((id=='tip' || id=='discount') && _value<0) _value=''
      const ss = {...s, map: id=='map' || id=='jsonmap', json, value: _value, error: _error, stale: _stale, preview: _preview, scroll: _scroll}
      console.log(`Field.handleChange ${id}, state`, {s, ss})
      switch (id) {
        case 'tip':
        case 'discount':
        p.setPurchase({[id]: _value, db, pk})
      }
      p.onFieldChange(id, ss)
      if (ss.stale != s.stale) p.onStale(id, ss.stale)
      console.log({Ref})
      _Field_[this.state.key].state = ss
      return ss
    })
  }
  callback = () => { // insert, update, delete
    const props = this.props
    const state = this.state
    const { v } = props
    const { id } = props.body
    const fid = _.JSON_[id]
    if ( !fid ) return
    this.setState(Field.getDerivedStateFromProps(props, state), () => {
      // if (props.toggle) props.toggle()
    })
  }
  render = () => {
    const prop = this.props
    const { connected, owner, uarr, darr, master, lang, cookie, vendor, u } = prop.master
    const { db, v, park } = prop
    const { sell, pk: _pk } = prop.table
    const pk = isNaN(_pk) ? _pk : Number(_pk)
    const newRow = pk<0 || isNaN(pk)
    const { verb: verb_, msg, vendorRow, cfgRow } = prop.row
    const { id, I, V, row, extra } = prop.body
    let verb = newRow && (v=='purchase' && ((owner && id=='discount') || id=='stock' || id=='tip' || _.JSONDELIVER_.includes(id)) || (v=='notice' && id=='memo')) ? (V.verb || 'insert') : verb_
    verb = id=='map' || id=='jsonmap' ? (v=='purchase' && pk>0 ? verb : 'insert') : verb
    if (u=='media' && id=='type') verb = 'default'
    if (u=='notice') {
      switch (id) {
        case 'title': verb='default'; break
        case 'type': verb='default'; break
        case 'price': verb='default'; break
        case 'stock': verb='default'; break
        case 'from': verb='default'; break
      }
    }
    if (v=='follows' && id=='modified') verb='default'
    let files = []
    const { scroll, required, htm, type, error, stale, preview, map} = this.state
    let Label = prop.Label || I.i.l || I.i
    let Input = row[id]
    let {value, expand, json} = this.state
    let date, style={display: 'inline'}
    if (_.CART_.includes(v) && row.stock) {debugger
      const stock = Number(row[id])
      value = stock < 0 ? 0 : stock
      if (stock < 0) debugger
    }
    if ((id=='tax' || id=='total') && _.CART_.includes(v)) value = Number(row[id])
    const Htm = _.Q_.includes(v) && verb=='default' ? 'div' : htm
    const htmId = `${db}${v}${pk}${verb}${id}${extra}${prop.index||''}`
    const htmProp = Object.assign({
      name: id,
      id: htmId,
      onChange: prop.onChange || this.onChange,
      className: prop.className ? [prop.className] : [],
    }, Field.PROP, V[htm])
    // if (required) {
    //   htmProp.required = required
    //   htmProp.style = {border: '2px dotted #ccc'}
    //   // htmProp.style = {border: '1px dashed green'}
    // }
    // if (v=='purchase' && newRow && id=='memo') htmProp.style = {display: expand ? 'inherit' : 'none'}
    if (prop.ID=='cart' && verb=='delete' && id=='memo') {
      htmProp.style = {display: expand ? 'inherit' : 'none'}
    }
    if (id=='tip' || id=='discount') {
      htmProp.onBlur = e => {
        e.preventDefault()
        e.stopPropagation()
        console.log({[id]: e.target.value})
        if (isNaN(e.target.value)) {
          debugger
          this.setState({value: ''})
        }
      }
    }
    if (prop.ID=='cart' && (id=='memo' || id=='stock') && verb=='delete') {
      htmProp.onBlur = e => {
        e.preventDefault()
        e.stopPropagation()
        console.log(this.state)
        const stale = !prop.neverStale
        const s = {cart: prop.cart}
        const memo = s.cart[4]
        const stock = s.cart[1]
        const purchaseDb = connected ? (Ref.online.state.select || prop.db) : prop.row.vendorRow.id
        console.log('online',{ID, Ref, connected, purchaseDb})
        if (id=='memo') {
          if (memo == e.target.value) return
          s.cart[4] = e.target.value
          prop.setCart({cart: [s.cart], db: purchaseDb, onChange: memo})
        }
        if (id=='stock') {
          const _stock = Number(e.target.value)
          if (_stock && stock==_stock) return // _stock = 0 no return
          s.cart[1] = _stock
          prop.setStock(_stock)
        }
        s.cart[5] = stale
        this.setState({stale})
      }
    }
    switch (htm) {
      case 'input':
      if (typeof htmProp.size == 'undefined') htmProp.size = 14
      break
      case 'textarea':
      // if (typeof htmProp.rows == 'undefined') htmProp.rows = 6
      // if (typeof htmProp.rows == 'undefined') htmProp.rows = prop.ID=='cart' && id=='memo' ? 2 : 6
      if (typeof htmProp.rows == 'undefined') htmProp.rows = 2
      if (typeof htmProp.cols == 'undefined') htmProp.cols = 16
      break
    }
    const htmType = prop.type || htmProp.type
    if (u=='media' && id=='album' && verb=='delete') htmProp['disabled'] = true
    htmProp.className.push(id)
    error && htmProp.className.push('error')
    stale && htmProp.className.push('stale')
    htmProp.className = htmProp.className.join(' ')
    if (htmProp.display=='none') return []
    const labelProp = {}
    if (verb!='default' || v=='login') labelProp.htmlFor = htmId
    const labelDivProp = {
      className: prop.label || 'l theme',
    }
    const htmDivProp = { className: prop.input || 'input' }
    const labelSelect = id=='selectmedia' ? (
      <div style={{display: 'inline', margin: '5px', padding: '5px'}}>
        <label { ...labelProp } className={ `selectmedia ${stale ? 'stale':''}` }>
          {
            master.select.i
          }
        </label>
      </div>
    ) : null
    switch (htmType) {
    case 'checkbox':
      if (verb=='delete' && id!='remember') htmProp['disabled'] = true // aria compliant
      htmProp.checked = value
      labelProp.className = `check text ${stale ? 'stale' : ''}`
      labelDivProp.className = 'l check'
      htmDivProp.className = 'input check right'
    break
    case 'file':
      htmDivProp.style = {display: 'inline', margin: '5px', padding: '5px'}
    break
    case 'button':
      if (id=='medias' || id=='items') {
        htmProp.onClick = this.onSelectClick
        htmProp.value = master.select.i
      }
    break
      // case 'datetime-local':
      // case 'password': case 'text': case 'textarea': case 'date': case 'number':
      // case 'number':
      // no break
    default:
      if (prop.type) htmProp.type = prop.type
      if (Htm==Field.HTM || Htm=='textarea') {
        htmProp.value = value
      }
    }
    const Required = required && (verb!='default' || v=='login') ? prop.master.required : ''
    Label = <label { ...labelProp }>{ I.i.l || I.i }{ Required }</label>
    if (prop.ID=='cart' && verb=='delete' && id=='memo') {
      Label = (
        <span
          onClick = {
            e => {
              e.stopPropagation()
              e.preventDefault()
              this.setState({ expand: !expand })
            }
          }
        >
          { Label } { expand ? uarr : darr }
        </span>
      )
    }
    const labelDiv = (
      <div { ...labelDivProp } key = { `${ htmId } label` }>
        { Label }
      </div>
    )
    const content = []
    var htmDiv
    style= value && value.length ? {maxHeight: '300px', margin: '1rem 20%', marginRight: '5px', overflow: 'scroll', padding: '5px'} : {}
    if (!stale && value && value.length) style.border = '1px solid #ccc'
    // if (!stale && value && value.length) style.border = `1px ${required ? 'dashed' : 'solid'} #ccc`
    switch (htm) {
    case 'select':
      const option = Object.keys(V[htm]['option']).reduce((acc, curr) => {
        const op = {value: curr, key: `${curr}`}
        acc.push(
          <option {...op}>
            { V[htm]['option'][curr] }
          </option>
        )
        return acc
      }, [])
      htmDiv = <div {...htmDivProp} key={`${htmId}input`}> <Htm {...htmProp}> {option} </Htm> </div>
      if (id=='lang' && (verb=='insert' || verb=='clone')) content.push(labelDiv, htmDiv)
    break
    case 'input':
    case 'textarea':
      htmDiv = <div {...htmDivProp} key={`${htmId}input`}> {labelSelect} {prop.body.V.before} <Htm {...htmProp}/> {prop.body.V.after} </div>
      switch (htmType) {
      case 'checkbox':
        if (_.Q_.includes(v)) {
          if (verb=='default') break
          // if (v=='purchase' && id!='deliver') break
          if (id=='test' && verb=='default') break
        }
        content.push(htmDiv, labelDiv)
      break
      case 'file': // SELMEDIA
        if (!(verb=='default' || verb=='delete')) content.push(labelDiv, htmDiv)
        files = this.files(htmId)
        files.length && content.push(
          <div style={style} key={`${htmId}file`} className={stale ? 'stale':''}>
            <ul className='medias'>
              {files}
            </ul>
          </div>
        )
      break
      case 'button':
        if (id=='map' || id=='jsonmap') {
          if (v != 'purchase' || newRow) content.push(labelDiv)
           if (map) {debugger
             // content.push(<Map {...prop} key={`${db}${v}${pk}${id}${_.MAP}`}/>)
           }
           else content.push(htmDiv)
        } else if (!(verb=='default' || verb=='delete')) content.push(labelDiv, htmDiv)
        if ((verb=='update' || verb=='insert') && (id=='medias' || id=='items')) {
          const bFilesContent = this.files(htmId)
          bFilesContent.length && content.push(
            <div style={style} key={`${htmId}${id}button`} className={stale ? 'stale':''}>
              <ul className={id}>
                {bFilesContent}
              </ul>
            </div>
          )
        }
      break
      default:
        if (_.Q_.includes(v)) {
          if (v=='purchase' && id=='stock') debugger
          if (id=='rate' && v!='review') break
          if (v=='purchase' && newRow && !Number(row.total)) {
            if (id=='discount') break
            if (id=='tip') break
          }
          if (u=='media' && id=='album') {
            break
          }
          if (verb!='default') content.push(labelDiv, htmDiv)
        } else content.push(labelDiv, htmDiv)
      }
    }
    if (_.Q_.includes(v) && verb=='default') {
      const p = {
        className: [id],
      }
      if (v=='media') p.className.push('medias')
      if (_.CART_.includes(v) && id=='tax' && !Number(Input*100)) Input=null
      let label = prop.label ? [prop.label] : ['l', 'theme']
      let input = prop.input ? [prop.input] : ['input']
      const bigIds = { ...park.login?.user?.default }
      if (typeof row[id] == 'string' && row[id].length == 0) Label=null
      switch (id) {
        case 'table':
        Input = row[id] && master[row[id]].i
        break
        case 'vendor':
        if (cfgRow) {
          Input = owner ? null : cfgRow.title
          input.push('title')
        }
        if (v=='purchase') Input=null
        break
        // case _.TO:
        // date = new Date(row.modified*1000)
        // Input = row[id]<0 ? master.new.i : (bigIds[row[id]] ? (bigIds[row[id]].name || bigIds[row[id]].username) : (date instanceof Date && !isNaN(date) ? date.toDateString() : master.new.i))
        // break
        case 'from':
        Label=null
        case 'customer':
        if (v=='purchase') {Input=null;break}
        case 'employee':
        case 'shipper':
        Input = row[id]<0 ? master.new.i : bigIds[row[id]] && (bigIds[row[id]].name || bigIds[row[id]].username)
        if (Input && pk>0 && bigIds[row[id]]) {
          Input =
          <a
            onClick={e => {
              e.stopPropagation()
              e.preventDefault()
              go(prop.history.push, [bigIds[row[id]].username])
            }}
          >
            {Input}
          </a>
        }
        break
        case 'modified':
        Label=null
        date = new Date(row[id]*1000)
        Input = date instanceof Date && !isNaN(date) ? date.toDateString() : master.new.i
        if (Input && pk>0 && bigIds[row.from] && bigIds[row.from]!='find' && v=='follows') {
          Input =
          <a onClick={e => {
              e.stopPropagation()
              e.preventDefault()
              go(prop.history.push, [bigIds[row.from].username])
            }}>
            {Input}
          </a>
        }
        break
        case 'stock':
        Label=null
        Input=null
        break
        case 'name':
        case 'title':
        Label=null
        input.push('h1', 'center', 'title')
        break
        case 'desc':
        input.push('h2', 'justify')
        break
        case 'memo':
        case 'detail':
        case 'verbal':
        input.push('h3', 'justify')
        break
        case 'tax':
        if (!(_.CART_.includes(v) || v=='notice')) Label=null
        break
        case 'currency':
        case 'print':
        Input=null
        break
        case 'uri': debugger; break
        case 'type':
        break
        case 'test':
        if (row[id]==0) Label=null
        Input=null
        break
        case 'rate':
        Input = `${row[id]} star`
        break
        case 'address':
        case 'city':
        case 'state':
        case 'code':
        case 'country':
        Label=null
        Input = `${row[id]}`
        break
        case 'open':
        p.className.push('v', 'flex')
        break
        case 'deliver':
        Input = row[id] ? 'yes': 'no'
        break
        case 'expire':
        Input = value
        break
        case 'album':
        if (pk>0) Input=master[row[id]].i
        // Label=null
        // Input=null
        // content.push(<Album {...prop} key={Album.ID}/>)
        break
      }
      if (!Input) Label=null
      switch (id) {
        case 'jsondeliver': debugger; break//if (v=='purchase') debugger
        case 'memo':
        // if (v=='purchase' && pk<0) debugger
        case 'desc':
        case 'detail':
        case 'verbal':
        Label = Label ? (
          <span
          /*
            style = {{
              display: '-webkit-box',
              WebkitLineClamp: 1,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              width: '100%',       // 👈 Forces it to take up available space
              wordBreak: 'break-all' // 👈 Optional: Prevents single massive words from breaking early
            }}
            */
            onClick = { e => {
              e.stopPropagation()
              e.preventDefault()
              this.setState({expand: !expand})
            }}>
            { Label }{ expand ? uarr : darr }
          </span>
        ) : null
        Input = <p style={{display: expand ? 'inherit': 'none'}}>{Input}</p>
      }
      p.className = p.className.join(' ')
      let deliver = false
      switch (id) {
        case 'medias':
        const medias = this.files(htmId)
        content.push(
          <ul
            key = { `${htmId}ulfiles` }
            id = { `${htmId}ulfiles` }
          >
            { medias }
          </ul>
        )
        break
        case 'items':
        case 'reviews':
        if (!row?.[id] || row[id]=='[]') break
        const pks = JSON.parse(row[id])
        const files = this.files(htmId)
        const tp = {
          ...prop,
          v: _.JSON_[id],
          pks,
          value,
          callback: this.callback, // insert, update, delete
          scroll,
          control:
            <ul id = { `${ htmId } ulfiles` }>
              { files }
            </ul>,
        }
        content.push(
          <Table
            {...tp}
            key = { `${ htmId } table` }
          />
        )
        break
        case _.JSONDELIVER_.includes(id):
        case 'deliverkm': if (v=='config') Input=row[id] + ' /km'
        case 'delivercost':
        case 'delivertip': deliver=true
        if(!_.CART_.includes(v) && !deliver) break
        if (Input && (newRow || deliver)) Input = `${Input} ${cfgRow ? cfgRow.currency:''}`
        break
        case 'tax': if (v=='config') break
        default:
        if (Label) Label = <div className={label.join(' ')}>{Label}</div>// <span {...p}>
        if (Input/*.length*/) Input = <div className={input.join(' ')}>{Input}</div>
        if (Label || Input) content.push(<div {...p} key={`${htmId}htm`}> {Label} {Input} </div>)
      } // switch id
    } // if verb==DEF
    Object.keys(V.s||{}).reduce((acc, key) => {
      const child = V.s[key]
      if (child.t) {
        if (!Test(child, login)) return acc // exclude based on login
        const childProp = {
          login: prop.login,
          action: prop.action,
          V: V.s[key],
          I: I.s[key],
          name: key,
        }
        switch (child.type) {
          case 'button':
          case 'control': acc.push(
            <Suspense fallback={<Loading/>} key = {key}>
              <Control { ...childProp } />
            </Suspense>
          )
          break
        }
      }
      return acc
    }, content)
    const prop_field = { className: `${id} ${ID}` }
    return (
      <div
        { ...prop_field }
        _id_ = { this.state._field_ }
      >
        { content }
      </div>
    )
  } // render

  files = htmId => {
    const prop = this.props
    const state = this.state
    const iState = Field.init(prop)
    const { uarr, darr, master, lang, cookie, vendor, u } = prop.master
    const { db, v, park } = prop
    const { sell, pk, offset, print } = prop.table
    const { verb, msg } = prop.row
    const { id, extra } = prop.body
    const { expand, selected, json, htm, type, value, error, stale, preview } = state
    const vId = id=='items' ? 'item' : (id=='medias' ? 'media' : (id=='reviews' ? 'review' : v))
    let key
    const onRemove = (e, i) => {
      e.stopPropagation()
      e.preventDefault()
      state.json.splice(i, 1)
      state.value.splice(i, 1)
      // state.stale = JSON.stringify(state.json)!=JSON.stringify(iState.json)
      state.stale = !equal(state.json, iState.json)
      // Fields[db][v][pk][verb][id][extra].state = state
      _Field_[state.key].state = state
      // _Field_[`${ db } ${ v } ${ pk } ${ verb } ${ id } ${ extra } `].state = state
      console.log(copy(state), 'onRemove')
      this.setState(copy(state))
      prop.onFieldChange(id, state)
    }
    const arrClick = (e, i, dir) => {
      e.stopPropagation()
      e.preventDefault()
      let _i=i
      if (dir=='u') _i--
      else _i++
      const vOrigin = value[i]
      const vChange = value[_i]
      const jOrigin = json[i]
      const jChange = json[_i]
      state.value.splice(_i, 1, vOrigin)
      state.value.splice(i, 1, vChange)
      state.json.splice(_i, 1, jOrigin)
      state.json.splice(i, 1, jChange)
      state.stale = JSON.stringify(json)!=JSON.stringify(iState.json)
      // Fields[db][v][pk][verb][id][extra].state = state
      _Field_[state.key].state = state
      // _Field_[`${ db } ${ v } ${ pk } ${ verb } ${ id } ${ extra } `].state = state
      this.setState(copy(state))
      prop.onFieldChange(id, state)
    }
    const content = json.reduce((acc, c, i) => {
      const {src, alt, title: _t, type, idx, pk: fpk, ...rest} = c
      if (!src) {debugger;return acc}
      const title = selected==i ? (state.title||_t) : _t
      key = `${db}${v}${pk}${verb}${id}${i}`
      const p = {
        ...rest,
        src,
        alt,
        title,
        type,
        'data-select': false,
        'data-scroll': iState.value.indexOf(c[id]),
        'data-idx': idx,
        'data-pk': fpk,
        // onClick: verb=='default' ? this.onChange : e => console.log('file clicked', {verb, src, title, selected, i}),
        style: {border: selected==i ? `1px dashed orange` : 'none'},
      }
      const style={border: selected==i ? `1px dashed orange` : 'none', margin: '5px', maxHeight: '48px', maxWidth: '160px', overflow: 'hidden'}
      if (pk<0 && v=='media') style.display = selected==fpk ? 'none' : 'initial'
      const Img = <img {...p}/>
      const length = id=='medias' ? 1 : 0 // value.length>1
      const Label =
          <label htmlFor = { htmId } >
            <div className = 'flex space'>
              <span
                onClick={e => onRemove(e, i)}
                className = 'theme'
                style = { {fontSize: 'x-small', margin: '5px'} }
              >
                { master.remove.i }
              </span>
              {
                Img
              }
              <div
                style = { style }
                onClick = {
                  e => {
                    e.stopPropagation()
                    e.preventDefault()
                    this.setState({selected: fpk})
                  }
                }
              >
                {
                  title
                }
                .
                {
                  type
                }
              </div>
              {
                pk < 0 && v == 'media' ? (
                  <input
                    value = { json[i].title }
                    style = { { display: selected==fpk?'initial':'none' } }
                    size = { 14 }
                    onChange = {
                      e => {
                        e.stopPropagation()
                        e.preventDefault()
                        json[i].title = e.target.value
                        this.setState({json})
                      }
                    }
                    onBlur = {
                      e => {
                        json[i].title = e.target.value
                        this.setState({json})
                      }
                    }
                  />
                ) : null
              }
              <div style = { { width: '24px' } }>
                {
                  fpk > 0 && length && i > 0 ? (
                    <div onClick = { e => arrClick(e, i, 'u') }>
                      {
                        uarr
                      }
                    </div>
                  ) : null
                }
                {
                  fpk > 0 && value.length > length && i < value.length-1 ? (
                    <div onClick = { e => arrClick(e, i, 'd') }>
                      {
                        darr
                      }
                    </div>
                  ) : null
                }
              </div>
            </div>
          </label>
      if (value.length > length && verb=='default') {
        // const currency = id=='medias'
        // const price = ''
        // i{i} x{idx} k{fpk}
        acc.push(
          <span
            { ...p }
            key = { key }
            style = { { display: id=='medias' ? 'inline' : 'block' } }
            onClick = { verb=='default' ? this.onChange : e => console.log('file clicked', {verb, src, title, selected, i}) }
          >
            <li>
              {
                Img
              }
            </li>
            <li>
              {
                id == 'medias' && state.title
              }
              {
                id=='items' && `${ prop.row?.cfgRow.currency } ${ prop.body?.row.price }`
              }
              {
                id=='reviews' && `stars ${ prop.body?.row.rating }`
              }
            </li>
          </span>
        )
      }
      else if (u=='media' && pk>0) {/*nothing*/}
      else if ((verb=='update' || verb=='insert')) {
        acc.push(<li key={key}>{Label}</li>)
      }
      return acc
    }, [])
    const moreProp = {
      ...prop,
      v,
      more: iState.value,
      value,
      callback: this.callback,
    }
    const more =
      <More
        {...moreProp }
        key = { `${ db }${ v }${ pk }${ id }${ More.ID }`}
      />
    if ((verb=='default' || verb=='update' || verb=='insert') && value.length < iState.value.length) content.push(more)
    return content
  }
}
export default Field
